import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=6c0bc20c&scoped=true&"
import script from "./ImageItem.vue?vue&type=script&lang=js&"
export * from "./ImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=6c0bc20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0bc20c",
  null
  
)

export default component.exports